
import Vue from 'vue'
import XTable from 'vux/src/components/x-table/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'

import DictLabel from '@/components/dict/DictLabel.vue'

var CostPage = Vue.extend({})
Vue.component('cost-page', CostPage)

export default {
  name: 'CostPage',
  components: {
    XTable, XButton, DictLabel, XInput, Group
  },
  props: {
    idArr: Array
  },
  data () {
    return {
      baseUrl: this.$store.state.url,
      oaAddr: this.$store.state.oaAddr,
      fileBasePath: this.$store.state.url + '/wechat/api/fileDownload',
      projectInfo: {},
      costInfo: {},
      arrangeDepartmentInfo: {},
      costWorkFilesInfo: [],
      picArr1: [], // 造价文件
      picArr2: [], // 工时汇总
      picArr3: [], // 委托单位信息
      costWorkPermission: []
    }
  },
  mounted () {
    const getPermissionPromise = this.axios({
      url: this.baseUrl + '/wechat/api/getCostWorkPermission/',
      method: 'get'
    }).then(({ data }) => {
      if (data.status === true) {
        const permissionInfo = data.permission
        if (permissionInfo && permissionInfo.status === true) {
          const permissionMap = permissionInfo.permission
          if (permissionMap) {
            const stepCode = this.idArr[3]
            this.costWorkPermission = permissionMap[stepCode]
          }
        }
      }
    }).catch((data) => {
    })
    Promise.all([
      getPermissionPromise
    ]).then(() => {
      this.init()
    })
  },
  methods: {
    init () {
      this.projectInfo = {}
      this.costInfo = {}
      this.arrangeDepartmentInfo = {}
      this.costWorkFilesInfo = []
      this.axios({
        url: this.baseUrl + '/wechat/api/projectInfo/' + this.idArr[0] + '/COST2' + '/' + this.idArr[1],
        method: 'post'
      }).then(({ data }) => {
        this.$vux.loading.hide()
        if (!this.isNull(data) && data.status === true) {
          this.projectInfo = data.projectInfo.info
          this.costInfo = data.costInfo.info
          this.arrangeDepartmentInfo = data.arrangeDepartment.info
          let permissionArray = Object.assign({}, this.costWorkPermission)
          let permissionObject = {}
          if (permissionArray) {
            for (let key in permissionArray) {
              permissionObject[permissionArray[key] + '_can'] = true
            }
          }
          let fileList = data.costWorkFiles.info
          if (data.costWorkFiles.status === true && Array.isArray(fileList)) {
            fileList = fileList.map((item) => ({
              ...item,
              ...permissionObject
            }))
            this.costWorkFilesInfo = fileList
          }
        }
      }).catch((response) => {
        this.$vux.loading.hide()
      })
    },
    getImg (imgType) {
      // if(imgType == 'worktree' && this.picArr1.length>0){//造价文件
      //   this.showImg(1);
      // }else if(imgType == 'worktime' && this.picArr2.length>0){//工时汇总
      //   this.showImg(2);
      // }else if(imgType == 'showUnitPage_1' && this.picArr3.length>0){//委托单位信息
      //   this.showImg(3);
      // }else{
      this.$vux.loading.show({
        text: '加载中'
      })
      this.picArr1 = []
      this.picArr2 = []
      this.picArr3 = []
      this.axios({
        url: this.baseUrl + '/wechat/commonFile/screenPage?taskId=' + this.idArr[0] + '&flowId=' + this.idArr[1] + '&stepId=' + this.idArr[2] + '&type=' + imgType,
        method: 'get'
      }).then((response) => {
        this.$vux.loading.hide()
        if (response.data.status == false) { // 返回失败
          this.showErr()
        } else { // 返回成功
          debugger
          if (imgType == 'showUnitPage_1') { // 委托单位信息
            let urlArr = response.data.imageUrl.split(',')
            for (let i = 0; i < urlArr.length; i++) {
              if (urlArr[i] != '') {
                this.picArr3.push(urlArr[i] + '?number=' + Math.random())
              }
            }
            if (this.picArr3.length > 0) {
              this.showImg(3)
            } else {
              this.showErr()
            }
          } else if (imgType == 'worktree') { // 造价文件
            let urlArr = response.data.imageUrl.split(',')
            for (let i = 0; i < urlArr.length; i++) {
              if (urlArr[i] != '') {
                this.picArr1.push(urlArr[i] + '?number=' + Math.random())
              }
            }
            if (this.picArr1.length > 0) {
              this.showImg(1)
            } else {
              this.showErr()
            }
          } else if (imgType == 'worktime') { // 工时汇总
            let urlArr = response.data.imageUrl.split(',')
            for (let i = 0; i < urlArr.length; i++) {
              if (urlArr[i] != '') {
                this.picArr2.push(urlArr[i] + '?number=' + Math.random())
              }
            }
            if (this.picArr2.length > 0) {
              this.showImg(2)
            } else {
              this.showErr()
            }
          }
        }
      }).catch((response) => {
        this.$vux.loading.hide()
        this.showErr()
      })
      // }
    },
    showImg (num) {
      let arrOnShow
      if (num == 1) {
        arrOnShow = this.picArr1
      } else if (num == 2) {
        arrOnShow = this.picArr2
      } else if (num == 3) {
        arrOnShow = this.picArr3
      }
      wx.previewImage({
        current: arrOnShow[0],
        urls: arrOnShow
      })
    },
    showErr () {
      this.$vux.alert.show({
        title: '暂无数据'
      })
      setTimeout(() => {
        this.$vux.alert.hide()
      }, 2000)
    },
    handleDownloadFile (fileId, fileName) {
      this.axios({
        url: this.baseUrl + '/wechat/commonFile/downloadForStream?fileId=' + fileId + '&flowId=' + this.idArr[1] + '&stepId=' + this.idArr[2],
        method: 'post',
        responseType: 'blob'
      }).then((res) => {
        if (!res) {
          this.$message.error('下载模板文件失败')
          return false
        }
        const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' })
        const downloadElement = document.createElement('a')
        const href = window.URL.createObjectURL(blob)
        // let contentDisposition = res.headers['content-disposition']  // 从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
        // let patt = new RegExp('filename=([^;]+\\.[^\\.;]+);*')
        // let result = patt.exec(contentDisposition)
        // let filename = decodeURI(result[1])
        downloadElement.style.display = 'none'
        downloadElement.href = href
        downloadElement.download = fileName // 下载后文件名
        document.body.appendChild(downloadElement)
        downloadElement.click() // 点击下载
        document.body.removeChild(downloadElement) // 下载完成移除元素
        window.URL.revokeObjectURL(href) // 释放掉blob对象

        // 路由跳转
        this.$router.push({
          path: '/file/download',
          query: {
            href: href,
            fileName: fileName
          }
        })
      })
    },
    getProperty (object, key) {
      if (this.isNull(object)) {
        return ''
      }
      const keyArr = key.split('.')
      let property = Object.assign({}, object)
      for (let i = 0; i < keyArr.length; i++) {
        property = property[keyArr[i]]
        if (this.isNull(property)) {
          return ''
        }
      }
      return property
    },
    isNull (v) {
      if (v === null || v === undefined || v == '') {
        return true
      }
      return false
    },
    updateCostWorkCost (costWorkFileId, costName, costValue) {
      const httpUrl = this.baseUrl + '/wechat/api/updateCostWorkCost'
      const params = {
        costWorkFileId: costWorkFileId,
        costName: costName,
        costValue: costValue
      }
      this.$http.post(httpUrl, params).then(({ data }) => {
        // 返回成功，
        if (data && data.status === true) {
          if (data.data && data.data.status === false) {
            this.$vux.alert.show({
              title: data.data.msg
            })
          }
        } else {
          this.$vux.alert.show({
            title: '数据异常'
          })
        }
      }).catch((data) => {
        debugger
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/detail/todo/business/cost/approval2.vue